import { makeRequest, CommonRequestOptions } from '../../makeRequest';

export type CreateUsersByUsernameOptions = CommonRequestOptions & {
   usernames: string[];
};

export function createUsersByUsername({
   usernames,
   ...common
}: CreateUsersByUsernameOptions): Promise<number[]> {
   return makeRequest('post', 'users/unique_usernames', {
      body: {
         unique_usernames: usernames,
      },
      ...common,
   });
}
